import { render, staticRenderFns } from "./ScorecardDashboardPane.vue?vue&type=template&id=2bfa8984&scoped=true&"
import script from "./ScorecardDashboardPane.vue?vue&type=script&lang=js&"
export * from "./ScorecardDashboardPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfa8984",
  null
  
)

export default component.exports